import classNames from 'classnames';
import type { PropsWithChildren, ReactNode } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  position: relative;
`;

const FrontWrapper = styled.div`
  opacity: 1;
  transition: opacity 0.5s cubic-bezier(0.26, 0, 0.29, 0.97);
  .swap & {
    opacity: 0;
    pointer-events: none;
  }
`;
const BackWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: opacity 0.5s cubic-bezier(0.26, 0, 0.29, 0.97);
  pointer-events: none;
  opacity: 0;
  overflow: hidden;
  .swap & {
    opacity: 1;
    pointer-events: auto;
  }
`;

type Props = {
  back: ReactNode;
  swap: boolean;
};

export const AnimatedContentSwap = ({
  children,
  back,
  swap,
}: PropsWithChildren<Props>) => {
  return (
    <Wrapper className={classNames({ swap })}>
      <FrontWrapper>{children}</FrontWrapper>
      <BackWrapper>{back}</BackWrapper>
    </Wrapper>
  );
};
